import React, { useContext, useState } from "react";
import "./LoginFormModalStyle.scss";
import { loginFormModalTextContent } from "./constant";
import CustomModal from "../Common_UI_Kit/CustomModal";
import CustomButton from "../Common_UI_Kit/CustomButton";
import CustomInput from "../Common_UI_Kit/CustomInput";
import { LoginContext } from "context/context";
import { operatorLogin } from "network/game.services";

const currencyOptions = loginFormModalTextContent.currencies.map((country) => ({
  label: country.currencyName,
}));
const languageOptions = loginFormModalTextContent.language.map((country) => ({
  label: country.languageName,
  code: country.code
}));

const LoginFormModal = () => {
  const [currencyCode, setCurrencyCode] = useState(currencyOptions[0])
  const [language, setLanguage] = useState(languageOptions[0])
  const [userName, setUserName] = useState(null)
  const [formError, setFormError] = useState(null)

  const { setLoginData, openLoginModal: isModalOpen, setOpenLoginModal: setIsModalOpen } = useContext(LoginContext)

  const handleOpenModal = () => {
    setIsModalOpen(true)
    const timeout = setTimeout(() => {
      handleInputFocus()
    }, 100)
    return () => clearTimeout(timeout)
  }
  const handleCloseModal = () => setIsModalOpen(false)

  const handleInputFocus = () => {
    const usernameInput = document.getElementById('username')
    if (usernameInput) {
      usernameInput.focus()
    }
  }

  const onLoginSuccess = (data) => {
    setLoginData({...data, currencyCode, language})
    setIsModalOpen(false)
    sessionStorage.setItem('loginData', (JSON.stringify(data)))
  }

  const handleLogin = () => {
    if(!userName) {
      setFormError('Please enter username.')
      return
    }
    operatorLogin(onLoginSuccess, { userName, currencyCode: currencyCode?.label })
  }

  const handleChange = (key, value) => {
    if (key === 'username') {
      setFormError(value ? null : 'Please Enter Username.')
      setUserName(value)}
    else if (key === 'currency') setCurrencyCode(value)
    else if (key === 'language') setLanguage(value)
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  }

  return (
    <>
      <CustomButton buttonType="primary" className="auth-btn" onClick={handleOpenModal}>
        Login
      </CustomButton>

      <CustomModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title={loginFormModalTextContent.ModalTitleText}
      >
        <div className="auth-form-wrap" onKeyDown={handleKeyDown} tabIndex={0}>
          <div className="auth-form-box">
            <CustomInput
              id='username'
              fieldType="textField"
              type="text"
              label="Username"
              placeholder="Enter Your Username"
              value={userName}
              onChange={(e) => handleChange('username', e.target.value)}
            />

            <CustomInput
              fieldType="selectField"
              type="text"
              label="Currency"
              placeholder="Select Your Currency"
              options={currencyOptions}
              defaultValue={currencyOptions[0].label}
              selectedOptions={currencyCode ? [currencyCode] : []}
              onChange={(selected) => handleChange('currency', selected?.[0])}
            />

            <CustomInput
              fieldType="selectField"
              type="text"
              label="Preferred Language"
              placeholder="Select Your Language"
              options={languageOptions}
              defaultValue={languageOptions[0].label}
              selectedOptions={language ? [language] : []}
              onChange={(selected) => handleChange('language', selected?.[0])}
            />
          </div>
          <div className="login-form-error">{formError}</div>

          <div className="btn-box">
            <CustomButton buttonType="secondary" label={loginFormModalTextContent.btnText} onClick={handleLogin} />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default LoginFormModal;
